module.exports = __webpack_public_path__ + "static/media/FilesFolder.41336af8.svg";